// extracted by mini-css-extract-plugin
export default {"title":"StuPhotos_title__JLpXh","list":"StuPhotos_list__CRNSd"};